<template>
  <div v-if="listMode">
    <div v-for="(quickLink, index) in quickStateLinks" :key="`city-quick-link-${index}`">
      <div class="pa-2 search-result" @click="$emit('city-quick-link-city-clicked', quickLink)">
        <v-icon dense color="#ED1E56" class="pa-0 mt-n1">mdi-city-variant-outline</v-icon>
        <span class="ml-3 font-weight-bold subtitle-2">{{ quickLink.city }}</span>
      </div>
      <v-divider v-if="index + 1 !== quickStateLinks.length" />
    </div>
  </div>

  <v-row v-else>
    <v-col cols="12" class="mb-3 text-center">
      <span v-if="!hideWebLink">
        <a @click="$emit('city-quick-link-web-clicked')">Web Offers</a>
        <span class="ml-2 mr-2">•</span>
      </span>
      <template v-for="(quickLink, index) in quickStateLinks">
        <span :key="`city-quick-link-${index}`">
          <a @click="$emit('city-quick-link-city-clicked', quickLink)">{{ quickLink.city }}</a>
          <span v-if="index + 1 !== quickStateLinks.length" class="ml-2 mr-2">•</span>
        </span>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'CityQuickLinks',

  props: {
    listMode: {
      type: Boolean,
      default: false,
    },
    hideWebLink: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    quickStateLinks: [
      {
        city: 'Salt Lake City',
        state: 'UT',
        latitude: 40.756095,
        longitude: -111.900719,
      },
      {
        city: 'Provo',
        state: 'UT',
        latitude: 40.2338438,
        longitude: -111.6585337,
      },
      {
        city: 'Boise',
        state: 'ID',
        latitude: 43.6166163,
        longitude: -116.200886,
      },
      {
        city: 'Phoenix',
        state: 'AZ',
        latitude: 33.4484367,
        longitude: -112.0741417,
      },
      {
        city: 'West Jordan',
        state: 'UT',
        latitude: 40.603552,
        longitude: -111.98704,
      },
    ],
  }),
})
</script>
